import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'shared/components/Button/Button';
import { Text } from 'shared/components/Text/Text';
import {
  AutopayTermConditionContainer,
  AutopayTermConditionContent,
  AutopayTermConditionFooter,
  TermConditionItem,
  TermConditionList,
} from './TermsAndConditionsModal.styles';

export type AutopayTermsAndConditionsModalProps = {
  primaryLanguage: string;
  onAccept: () => void;
  onDecline: () => void;
};

export function TermsAndConditionsModal({
  primaryLanguage,
  onAccept,
  onDecline,
}: AutopayTermsAndConditionsModalProps) {
  const { t, i18n } = useTranslation();
  const bodyList: string[] = t('autopayModal.termConditionBody', {
    returnObjects: true,
  }) as string[];

  useEffect(() => {
    if (primaryLanguage === 'es') {
      i18n.changeLanguage('es');
    }
  }, [i18n, primaryLanguage]);

  return (
    <AutopayTermConditionContainer>
      <Text as="h2">{t('autopayModal.termCondition')}</Text>
      <AutopayTermConditionContent>
        <Text as="h3" $margin="0 0 20px 0">
          {t('autopayModal.termConditionTitle')}
        </Text>
        <TermConditionList>
          {Array.isArray(bodyList) &&
            bodyList.map((item) => (
              <TermConditionItem key={item}>
                <Text as="p">{item}</Text>
              </TermConditionItem>
            ))}
        </TermConditionList>
      </AutopayTermConditionContent>
      <AutopayTermConditionFooter>
        <Button
          label={t('autopayModal.declineButton')}
          styleVariant="secondary"
          onClick={onDecline}
        />
        <Button label={t('autopayModal.acceptButton')} onClick={onAccept} />
      </AutopayTermConditionFooter>
    </AutopayTermConditionContainer>
  );
}

export default TermsAndConditionsModal;
